import { Grid, IconButton, InputLabel } from "@material-ui/core";
import ImageIcon from "@material-ui/icons/Image";
import FormatBoldIcon from "@material-ui/icons/FormatBold";
import FormatItalicIcon from "@material-ui/icons/FormatItalic";
import InsertLinkIcon from "@material-ui/icons/InsertLink";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import { useEffect, useRef, useState } from "react";

export function TextEditor(props) {
  const {
    onChange,
    initialValue = "",
    label,
    autoFocus,
    rows = 4,
    multiline = true,
    resize = "vertical",
    panel = ["bold", "italic", "image", "link", "orderedList", "unorderedList"],
  } = props;
  const [value, setValue] = useState(initialValue);
  const [newCursor, setNewCursor] = useState(null); //used to put cursor after inserted text
  const editorRef = useRef();
  const insertSomething = (e, something) => {
    // something: function (string) -> string
    const { selectionStart, selectionEnd } = editorRef.current;
    const preSelection = value.substring(0, selectionStart);
    const postSelection = value.substring(selectionEnd);
    const selection = value.substring(selectionStart, selectionEnd);
    const insertedString = something(selection);
    const res = `${preSelection}${insertedString}${postSelection}`;
    setValue(res);
    editorRef.current.focus();
    setNewCursor([selectionStart, selectionStart + insertedString.length]);
    onChange({ ...e, target: { ...e.target, value: res } });
  };
  useEffect(() => {
    if (newCursor) {
      editorRef.current.setSelectionRange(newCursor[0], newCursor[1]);
      setNewCursor(null);
    }
  }, [newCursor]);
  const insertImage = (e) =>
    insertSomething(e, (selection) => `<img src="${selection}">`);
  const insertLink = (e) =>
    insertSomething(e, (selection) => `<a href="">${selection}</a>`);
  const formatBold = (e) =>
    insertSomething(e, (selection) => `<b>${selection}</b>`);
  const formatItalic = (e) =>
    insertSomething(e, (selection) => `<i>${selection}</i>`);
  const insertOrderedList = (e) =>
    insertSomething(
      e,
      (selection) =>
        `<ol>
${selection.replace(/^/g, "<li>").replace(/\n/g, "\n<li>")}
</ol>`
    );
  const insertUnorderedList = (e) =>
    insertSomething(
      e,
      (selection) =>
        `<ul>
${selection.replace(/^/g, "<li>").replace(/\n/g, "\n<li>")}
</ul>`
    );
  const onChangeDecorated = (e) => {
    setValue(e.target.value);
    onChange(e);
  };
  const buttons = {
    bold: (
      <IconButton onClick={formatBold} key="bold">
        <FormatBoldIcon />
      </IconButton>
    ),
    italic: (
      <IconButton onClick={formatItalic} key="italic">
        <FormatItalicIcon />
      </IconButton>
    ),
    image: (
      <IconButton onClick={insertImage} key="image">
        <ImageIcon />
      </IconButton>
    ),
    link: (
      <IconButton onClick={insertLink} key="link">
        <InsertLinkIcon />
      </IconButton>
    ),
    orderedList: (
      <IconButton onClick={insertOrderedList} key="orderedList">
        <FormatListNumberedIcon />
      </IconButton>
    ),
    unorderedList: (
      <IconButton onClick={insertUnorderedList} key="unorderedList">
        <FormatListBulletedIcon />
      </IconButton>
    ),
  };

  return (
    <Grid container>
      <InputLabel>{label}</InputLabel>
      {panel && (
        <Grid item xs={12}>
          {panel.map((button) => buttons[button])}
        </Grid>
      )}
      <Grid item xs={12}>
        <textarea
          style={{
            border: "solid gray",
            borderWidth: "1px 1px 1px 1px",
            width: "100%",
            boxSizing: "border-box",
            resize,
          }}
          value={value}
          onChange={onChangeDecorated}
          ref={editorRef}
          autoFocus={autoFocus}
          {...{ rows, multiline }}
        />
      </Grid>
    </Grid>
  );
}
